import React from 'react';
import { Grid } from '@material-ui/core';
import { getDashboardCaseDetails } from 'src/services/cases.service';
import ProgressNotesContainer from './ProgressNotesContainer';
import MessagesContainer from './MessagesContainer';
import ContactsContainer from './ContactsContainer';
import DocumentBlockContainer from './DocumentBlockContainer';
import DetailsCardPres from '../Presentation/DetailsCardPres';
import ActionBlockPres from '../Presentation/ActionBlockPres';

export class DashBoardViewContainer extends React.Component {
  state = { employerHeaderData: null };

  componentDidMount() {
    let caseId = this.props.caseId;
    if (caseId) {
      this.setState({ employerHeaderData: null });
      getDashboardCaseDetails(caseId, 'true').then(resp => {
        this.setState({ employerHeaderData: resp });
      });
    }
  }

  render() {
    return (
      <div style={{ padding: '20px' }}>
        <DetailsCardPres
          headerData={this.state.employerHeaderData}
          caseDetail={this.props.caseDetail}
          isCorp={this.props.isCorp}></DetailsCardPres>
        <Grid container spacing={4}>
          <Grid item sm={6}>
            <ActionBlockPres caseId={this.props.caseId} caseData={this.state.employerHeaderData} caseDetail={this.props.caseDetail} />
            <ProgressNotesContainer caseId={this.props.caseId} />
          </Grid>
          <Grid item sm={6}>
            <DocumentBlockContainer caseId={this.props.caseId} history={this.props.history} />
            <MessagesContainer caseId={this.props.caseId} caseNumber={this.props.caseNumber} history={this.props.history} />
            <ContactsContainer caseId={this.props.caseId} history={this.props.history} />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default DashBoardViewContainer;
